import { receptionTypeValues } from 'constants/receptions'

export const UIReceptionType = {
  EXPERT: 'expert',
  PURCHASE: 'purchase',
  AUCTION: 'auction',
  SALES_ORDER: 'sales_order',
  FAST_TRACK: 'fast_track',
}

export const uiReceptionTypeOptions = [
  UIReceptionType.PURCHASE,
  UIReceptionType.AUCTION,
  UIReceptionType.SALES_ORDER,
  UIReceptionType.EXPERT,
]

export const Category = {
  INTAKE: 'intake',
  EXPERT: 'expert',
}

export const DBType = {
  PURCHASE: receptionTypeValues.PURCHASE,
  AUCTION: receptionTypeValues.AUCTION,
  SALES_ORDER: receptionTypeValues.SALES_ORDER,
  EXPERT: receptionTypeValues.EXPERT,
}

export function toDbType(uiType) {
  switch (uiType) {
    case UIReceptionType.PURCHASE:
      return DBType.PURCHASE
    case UIReceptionType.AUCTION:
      return DBType.AUCTION
    case UIReceptionType.SALES_ORDER:
      return DBType.SALES_ORDER
    case UIReceptionType.EXPERT:
      return DBType.EXPERT
    default:
      return undefined
  }
}

export function toCategory(uiType) {
  switch (uiType) {
    case UIReceptionType.PURCHASE:
    case UIReceptionType.AUCTION:
    case UIReceptionType.SALES_ORDER:
      return Category.INTAKE
    case UIReceptionType.EXPERT:
      return Category.EXPERT
    case UIReceptionType.FAST_TRACK:
      return undefined // separate collection
    default:
      return undefined
  }
}

export const isIntakeUIType = uiType =>
  uiType === UIReceptionType.PURCHASE || uiType === UIReceptionType.AUCTION || uiType === UIReceptionType.SALES_ORDER

export const isExpertUIType = uiType => uiType === UIReceptionType.EXPERT

export const isFastTrackUIType = uiType => uiType === UIReceptionType.FAST_TRACK

export const intakeUIOptions = [UIReceptionType.PURCHASE, UIReceptionType.AUCTION, UIReceptionType.SALES_ORDER]

export const expertUIOptions = [UIReceptionType.EXPERT]

export const getUIReceptionTypeLabel = (uiType, t) => {
  switch (uiType) {
    case UIReceptionType.PURCHASE:
      return t('toSell')
    case UIReceptionType.AUCTION:
      return t('toAuction')
    case UIReceptionType.SALES_ORDER:
      return t('salesOrder')
    case UIReceptionType.EXPERT:
      return t('expert')
    default:
      return ''
  }
}

export const uiReceptionToggleOptions = t =>
  uiReceptionTypeOptions.map(value => ({ value, title: getUIReceptionTypeLabel(value, t) }))

// Helpers that work across new model (type field) and legacy model (boolean flags / purposeOfSale)
export const isPurchaseReception = data => data?.type === 'purchase' || !!data?.mightBuyProducts
export const isAuctionReception = data => data?.type === 'auction' || !!data?.hasProductsSoldOnBehalf

export const isSalesOrderReception = data =>
  data?.type === 'sales_order' || (Array.isArray(data?.purposeOfSale) && data.purposeOfSale.includes('sales_order'))

const LEGACY_EXPERT_PURPOSES = ['evaluation', 'estate_inventory', 'insurance_evaluation', 'gemmological_examination']
export const isExpertReception = data =>
  data?.type === 'expert' ||
  (Array.isArray(data?.purposeOfSale) && data.purposeOfSale.some(p => LEGACY_EXPERT_PURPOSES.includes(p)))
